import Button from '@mui/material/Button';
import { TRPCClientError } from '@trpc/client';

import { useDataElTagGenerator } from '#utils/use-data-el-tag-generator.js';

export type GenericErrorBoundaryRenderProps = {
	buttonText: string;
	error: unknown;
	onButtonClick: () => void;
};

export function GenericErrorBoundaryRender({ error, buttonText, onButtonClick }: GenericErrorBoundaryRenderProps) {
	const el = useDataElTagGenerator(GenericErrorBoundaryRender);

	const requestId =
		(
			error instanceof TRPCClientError &&
			typeof error.data === 'object' &&
			error.data !== null &&
			'requestId' in error.data
		) ?
			(error.data as { requestId?: string }).requestId
		:	undefined;

	return (
		<div {...el()} className='flex min-h-0 max-w-full grow flex-col items-center justify-center gap-8 p-4'>
			<div {...el('container')} className='flex max-h-fit min-h-0 w-[70rem] max-w-full grow flex-col gap-2'>
				<div {...el('header')} className='flex shrink-0 basis-auto items-end justify-between gap-4'>
					<div className='ml-1 flex min-w-0 grow basis-auto flex-col gap-2'>
						<h1 className='text-3xl font-bold'>Something went wrong.</h1>
						{error instanceof Error && (
							<p title={error.message} className='line-clamp-3 min-w-0 [text-box:initial]'>
								{error.message}
							</p>
						)}
						{requestId && (
							<p className='text-sm text-gray-11'>
								Reference: <code className='font-mono select-all'>{requestId}</code>
							</p>
						)}
					</div>

					<Button onClick={onButtonClick}>
						<span>{buttonText}</span>
					</Button>
				</div>

				{error instanceof Error ?
					<div
						{...el('details')}
						className='flex max-h-max min-h-0 min-w-0 shrink basis-auto overflow-auto rounded-md bg-gray-a3 p-4'
					>
						<pre className='text-sm'>
							{error instanceof TRPCClientError ? JSON.stringify(error.data, null, '\t') : error.stack}
						</pre>
					</div>
				:	null}
			</div>
		</div>
	);
}
